// export * from "./sorters"
// export * from "./filters"
// export * from "./mappers"
// export * from "./reducers"
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as map from "./mappers";
import * as sort from "./sorters";
import * as filter from "./filters";
import * as reduce from "./reducers";
function composer(method, data, name) {
    return { name: name, method: method, cb: data[name] };
}
export var allComposables = __spread(Object.keys(map).map(composer.bind(void 0, "map", map)), Object.keys(sort).map(composer.bind(void 0, "sort", sort)), Object.keys(reduce).map(composer.bind(void 0, "reduce", reduce)), Object.keys(filter).map(composer.bind(void 0, "filter", filter))).reduce(function (a, b) {
    a[b.name] = b;
    return a;
}, {});
//# sourceMappingURL=index.js.map